(function ($) {
  if (typeof $ !== 'function') {
    return;
  }

  const normalizeUrl = (url) => String(url || '').replace(/\/+$/, '');

  const clearInfiniteScrollTrigger = () => {
    const $pagination = $('.zw-pagination');

    if (!$pagination.length) {
      return;
    }

    $pagination.empty();
  };

  $(document).on('ald_ajax_content_success', function (event, args) {
    const $nextLink = $('.zw-pagination a.zw-next-page').first();
    const loadedUrl = normalizeUrl(args && args.target_url ? args.target_url : '');

    if (!$nextLink.length) {
      clearInfiniteScrollTrigger();
      return;
    }

    if (loadedUrl && normalizeUrl($nextLink.prop('href')) === loadedUrl) {
      clearInfiniteScrollTrigger();
    }
  });
})(jQuery);
